import { render, staticRenderFns } from "./manage-employees.vue?vue&type=template&id=0263abb2&"
import script from "./manage-employees.vue?vue&type=script&lang=js&"
export * from "./manage-employees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports